<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
   <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
    <!-- <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="validateForm" @success="onSuccess"> -->
    
    <z-page :title="title">
    <!-- <div class="w-card__content content-hardcode"> -->
        
    <br>

      <w-tabs :items="tabs" :no-slider="false" active-class="primary" v-model="activeTab">
      <!-- Tab Method Start -->
         <template #item-content.1>
             <br><br>
                <w-flex justify-center align-center>
                   <div class="w-flex wrap smd-column" >
                      <div class="grow " >
                        <z-select class="mt4" outline :items="premis" label="ID / Nama Premis *"  v-model="form.premis_id" @input="getTernakan(form, 2)" :validators="[validators.required]"/>
                     </div>
                     <div class="mx2"></div>
                     <div class="grow " >
                        <br>
                        <div style="margin:17px;" class="fw-normal my1 fs-1"><b>Negeri : </b>{{form.lkp_negeri}}</div>
                     </div>
                  </div>
               </w-flex>   

               <w-flex justify-center align-center>
                  <div class="w-flex wrap smd-column" >
                     <div class="grow " >
                        <z-select class="mt4" outline :items="lkp_ternakan" label="Jenis Ternakan *"  v-model="form.lkp_ternakan_id" @input="getTernakan(form, 3)" :validators="[validators.required]"/>
                     </div>
                     <div class="mx2"></div>
                     <div class="grow " >
                         <z-select class="mt4" outline :items="jenis_baka" label="Jenis Baka *"  v-model="form.lkp_jenis_baka_id" @input="getTernakan(form, 3)" :validators="[validators.required]"/>
                     </div>
                  </div>
               </w-flex>
             <br><br>
             <br><br>

         </template>

        <template #item-content.2>
             <br><br>
             
             <!-- KOTAK CARIAN FULL WIDTH & MENARIK -->
             <div style="background-color: #f8f9fa; padding: 15px 20px; border-radius: 8px; margin-bottom: 20px; border: 1px solid #e0e0e0;">
                <w-flex align-center>
                   <div style="flex: 1;">
                      <w-input 
                         v-model="searchQuery" 
                         placeholder="Taip untuk mencari (ID Ternakan, Nama Ternakan, atau No. Pendaftaran)..." 
                         outline 
                         style="width: 100%;"
                         class="search-input-custom"
                      >
                         <template #prepend>
                            <w-icon color="primary" class="ml2">fal fa-search</w-icon>
                         </template>
                         <!-- Butang Clear (Pangkah) jika ada teks -->
                         <template #append v-if="searchQuery">
                            <w-button bg-color="transparent" color="grey" @click="searchQuery = ''" class="mr1">
                               <w-icon>fal fa-times</w-icon>
                            </w-button>
                         </template>
                      </w-input>
                   </div>
                </w-flex>
             </div>

             <div class="w-table-wrap" style="max-height: 400px; border-radius: 8px; border: 1px solid #e0e0e0;">
                <div class="table-profil-scrol">
                    <table class="w-table" color="light" >
                     <thead>
                        <tr>
                          <th class="w-table__header  text-center" width="1%">BIL</th>
                          <th class="w-table__header  text-center">NO. PENDAFTARAN</th>
                          <th class="w-table__header  text-center">ID | NAMA TERNAKAN</th>
                          <th class="w-table__header  text-center">ID INDUK</th>
                          <th class="w-table__header  text-center">BAKA</th>
                          <th class="w-table__header  text-center">JANTINA</th>
                          <th class="w-table__header  text-center">TARIKH LAHIR</th>
                          <th class="w-table__header  text-center">UMUR</th>
                          <th class="w-table__header  text-center"><w-checkbox v-model="checkin" @change="klickPilih()" ></w-checkbox></th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- TUKAR: template v-if dan v-for menggunakan data yang difilter -->
                        <template v-if="filteredTernakanList.length == 0">
                          <tr class="w-table__row" >
                            <td class="w-table__cell text-center" colspan="9"> Tiada Data.</td>
                          </tr>
                        </template>
                        <template v-for="(dt, ind) in filteredTernakanList" :key="ind">
                          <tr class="w-table__row" >
                            <td class="w-table__cell text-center" >{{ind+1}}</td>
                            <td class="w-table__cell text-center" >{{dt.kode}}</td>
                            <td class="w-table__cell text-center" style="text-transform: uppercase;">{{dt.id_ternakan}} | {{dt.nama_ternakan}}</td>
                            <td class="w-table__cell text-center" >{{dt.id_ibu}} | {{dt.nama_ibu}}</td>
                            <td class="w-table__cell text-center" >{{dt.lkp_baka}}</td>
                            <td class="w-table__cell text-center" >{{dt.jantina}}</td>
                            <td class="w-table__cell text-center" >{{$zutil.dateformat(dt.tarikh_lahir ? dt.tarikh_lahir : '' )}}</td>
                            <td class="w-table__cell text-center" >{{$zutil.umurbulan(dt.tarikh_lahir)}}</td>
                            <td class="w-table__cell text-center"><div class="title4 mb2"></div>
                                 <template v-if="dt.baka == null">
                                    <w-checkbox v-model="dt.pilih" @input="klickPi(dt) "></w-checkbox>
                                 </template>
                                 <template v-else>
                                    <template v-if="dt.sudah_pilih == 1">
                                       <w-checkbox v-model="dt.pilih" @input="klickPi(dt) "></w-checkbox>
                                    </template>
                                 </template>
                              </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                </div>
             </div>
             <br><br>
         </template>

         <template #item-content.3>
             <br><br>
             <div class="w-table-wrap" style="max-height: 400px;">
                <div class="table-profil-scrol">
                    <table class="w-table" color="light" >
                      <thead>
                        <tr>
                          <th class="w-table__header  text-center" width="1%">BIL</th>
                          <th class="w-table__header  text-center">NO. PENDAFTARAN</th>
                          <th class="w-table__header  text-center">ID | NAMA TERNAKAN</th>
                          <th class="w-table__header  text-center">ID INDUK *</th>
                          <th class="w-table__header  text-center">ID PEJANTAN *</th>
                          <th class="w-table__header  text-center">BAKA</th>
                          <th class="w-table__header  text-center">GRED</th>
                          <th class="w-table__header  text-center">JANTINA</th>
                          <th class="w-table__header  text-center">TARIKH LAHIR</th>
                          <th class="w-table__header  text-center">UMUR (BULAN)</th>
                          <th class="w-table__header  text-center">GAMBAR TERNAKAN *</th>
                          <th class="w-table__header  text-center">SIJIL PEDIGREE *</th>
                          <th class="w-table__header  text-center">STATUS</th>
                          <th class="w-table__header  text-center"  width="10%">TINDAKAN</th>
                        </tr>
                      </thead>
                       <tbody>
                        <template v-if="form.ternakan_list.length == 0">
                          <tr class="w-table__row" >
                            <td class="w-table__cell text-center" colspan="9"> Tiada Data.</td>
                          </tr>
                        </template>
                        <template v-for="(dt, ind) in form.ternakan_list">
                          <tr class="w-table__row" >
                            <td class="w-table__cell text-center" >{{ind+1}}</td>
                            <td class="w-table__cell text-center" >{{dt.id_ternakan}}</td>
                            <td class="w-table__cell text-center" style="text-transform: uppercase;">{{dt.ternakan_nama}}</td>
                            <td class="w-table__cell text-center" >{{dt.id_ibu}} | {{dt.nama_ibu}}</td>
                            <td class="w-table__cell text-center" >{{dt.id_bapa}} | {{dt.nama_bapa}}</td>
                            <td class="w-table__cell text-center" >{{dt.lkp_baka}}</td>
                            <td class="w-table__cell text-center" >
                              {{dt.lkp_gred}} |
                              <template v-if="dt.lkp_gred_id >= 5">
                                 TULEN
                              </template>
                              <template  v-else-if="dt.lkp_gred_id <= 4">
                                 HYBRID
                              </template>
                            </td>
                            <td class="w-table__cell text-center" >{{dt.jantina}}</td>
                            <td class="w-table__cell text-center" >{{$zutil.dateformat(dt.tarikh_lahir ? dt.tarikh_lahir : '' )}}</td>
                            <td class="w-table__cell text-center" >{{$zutil.umurbulan(dt.tarikh_lahir)}}</td>
                            <td class="w-table__cell text-center">
                                <w-tooltip top color="white" bg-color="black">
                                  <template #activator="{ on }">
                                    <w-button 
                                      dark 
                                      class="green--bg ml1" 
                                      v-on="on"
                                      @click="Gambar(dt)" 
                                      v-if="form.lkp_status_id == 19"
                                    ><div style="width: 6px"></div>
                                      <w-icon md class="mr2">fal fa-upload</w-icon> 
                                    </w-button>
                                  </template>
                                  Muat naik gambar (Upload)
                                </w-tooltip>
                                <template v-for="(d, ind) in dt.atthectment_image" :key="ind">
                                  <div class="fw-normal my1 fs-1">  
                                    <a :href="d.url" target="_blank">{{ d.name }}</a>
                                    <w-button bg-color="error-dark1" @click="deletelAttahecmentImg(d.id)">
                                      <w-icon xs>fal fa-trash</w-icon>
                                    </w-button>
                                  </div>
                                </template>
                              </td>
                            <td class="w-table__cell text-center">
                             <w-tooltip top color="white" bg-color="black">
                               <template #activator="{ on }">
                                 <w-button 
                                   dark 
                                   class="green--bg ml1" 
                                   v-on="on"
                                   @click="Sijil(dt)" 
                                   v-if="form.lkp_status_id == 19"
                                 ><div style="width: 6px"></div>
                                   <w-icon md class="mr2">fal fa-upload</w-icon>
                                 </w-button>
                               </template>
                               Muat naik sijil (Upload Sijil)
                             </w-tooltip>
                             <template v-for="(d, ind) in dt.atthectment_sijil" :key="ind">
                               <div class="fw-normal my1 fs-1">  
                                 <a :href="d.url" target="_blank">{{ d.name }}</a>
                                 <w-button bg-color="error-dark1" @click="deletelAttahecmentImg(d.id)">
                                   <w-icon xs>fal fa-trash</w-icon>
                                 </w-button>
                               </div>
                             </template>
                           </td>
                            <td class="w-table__cell text-center" >
                              <template v-if="dt.id_ibu == null">
                                 Belum Dikemaskini
                              </template>
                              <template v-else>
                                 Sudah Dikemaskini
                              </template>
                            </td>
                            <td class="w-table__cell text-center">
                              <w-tooltip md top color="white" bg-color="black" >
                                 <template #activator="{ on }">
                                    <w-button  bg-color="warning" @click="Ternakan(dt)" v-if="form.lkp_status_id == 19 && $zutil.anyRole(['2','5'])" v-on="on" class="be fs-2"><div style="width: 6px"></div> 
                                          <w-icon class="mr1" md >fal fa-pencil</w-icon>
                                    </w-button>
                                 </template>
                                    KEMASKINI
                              </w-tooltip>

                             <!--  <w-tooltip md top color="white" bg-color="black" >
                                 <template #activator="{ on }">
                                    <w-button bg-color="primary" @click="Ternakan(dt)" v-if="form.lkp_status_id == 19 && dt.id_ibu != null && $zutil.anyRole(['2'])" v-on="on" class="w-button w-button--dark size--md info-dark1--bg">
                                       <div style="width: 8px"></div> 
                                        <w-icon md class="mr2">fal fa-eye</w-icon>
                                    </w-button>
                                 </template>
                                    PAPAR
                              </w-tooltip> -->
                               &nbsp;
                               <w-tooltip top color="white" bg-color="black">
                                 <template #activator="{ on }">
                                    <w-button class="be fs-2" v-on="on" bg-color="error-dark1" dark tile @click="destroyTernakan(dt.id)" v-if="form.lkp_status_id == 19">
                                       <div style="width: 8px"></div>
                                       <w-icon md class="mr2">fal fa-trash</w-icon> 
                                    </w-button>
                                 </template>
                                 PADAM
                                </w-tooltip>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                   </table>
                </div>
             </div>
             <br><br>
             <br><br>

              <div class="w-table-wrap" style="max-height: 400px;">
                <div class="table-profil-scrol">
                    <table class="w-table" color="light" >
                      <thead>
                        <tr>
                          <th class="w-table__header  text-center" width="1%">BIL</th>
                          <th class="w-table__header  text-center">KETERANGAN</th>
                          <th class="w-table__header  text-center">NAMA FAIL</th>
                          <th class="w-table__header  text-center">NO KES</th>
                          <th class="w-table__header  text-center">TINDAKAN</th>
                        </tr>
                      </thead>
                       <tbody>
                        <!-- <template v-if="form.baka_dokumen_list.length == 0">
                          <tr class="w-table__row" >
                            <td class="w-table__cell text-left" colspan="9"> Tiada Data.</td>
                          </tr>
                        </template> -->
                        <template v-for="(dt, ind) in form.baka_dokumen_list">
                          <tr class="w-table__row" >
                            <td class="w-table__cell text-center" >{{ind+1}}</td>
                            <td class="w-table__cell text-center" >{{dt.nama}}</td>
                            <td class="w-table__cell text-center">
                               <template v-for="d, ind  in dt.atthectment_dokumen">
                                       <div class="fw-normal my1 fs-1">  
                                          <a :href="d.url">{{ d.name }}</a> 
                                          <w-button  bg-color="error-dark1"  @click="deletelAttahecmentDokumen(d.id)" ><w-icon xs >fal fa-trash</w-icon></w-button>
                                       </div>
                                    </template>
                            </td>
                            <td class="w-table__cell text-center">
                              <w-tooltip md top color="white" bg-color="black">
                                 <template #activator="{ on }">
                                    <a v-on="on" 
                                       @click="url_kes(dt.no_kes)" 
                                       style="text-decoration: underline; color: #3a3ad0;">
                                       {{ dt.no_kes }}
                                    </a>
                                 </template>
                                 <span>
                                    https://myvetlab.dvs.gov.my/myvetlabservis/senarai-keputusan-smartfarming.php?no_kes={{ dt.no_kes }}
                                 </span>
                              </w-tooltip>
                            </td>
                            <td class="w-table__cell text-center">
                              <w-tooltip md top color="white" bg-color="black" >
                                 <template #activator="{ on }">
                                    <w-button  bg-color="warning" @click="Dokumen(dt)" v-if="form.lkp_status_id == 19 && $zutil.anyRole(['2','5'])" v-on="on" class="be fs-2"><div style="width: 6px"></div> 
                                          <w-icon class="mr1" md >fal fa-pencil</w-icon>
                                    </w-button>
                                 </template>
                                    KEMASKINI
                              </w-tooltip>
                               &nbsp;
                               <w-tooltip top color="white" bg-color="black">
                                 <template #activator="{ on }">
                                    <w-button class="be fs-2" v-on="on" bg-color="error-dark1" dark tile @click="destroyDokumen(dt.baka_dokumen_id)" v-if="form.lkp_status_id == 19 && dt.id == null">
                                       <div style="width: 8px"></div>
                                       <w-icon md class="mr2">fal fa-trash</w-icon> 
                                    </w-button>
                                 </template>
                                 PADAM
                                </w-tooltip>
                            </td>
                          </tr>
                        </template>
                       </tbody>
                    </table>
                 </div>
              </div>

            <w-flex class="mt3" wrap align-center justify-end v-if="$zutil.anyRole(['1', '2', '5'])">
             
               <w-button class="my1"  @click="Dokumen_baru(form)" v-if="form.lkp_status_id == 19 && $zutil.anyRole(['2','5'])">
                  <w-icon class="mr1">fal fa-upload</w-icon> 
                  Muat Naik Dokumen
               </w-button>
            </w-flex>

             <br><br>
          </template>
      </w-tabs>

      <w-flex class="mt3" wrap align-center justify-end v-if="$zutil.anyRole(['1', '2', '5'])">
        <template v-if="activeTab == 0">
            <w-button class="my1" type="submit" @click="getTernakan(form);">
               SETERUSNYA
            </w-button>
         </template>
         <template v-else-if="activeTab == 1 && (form.lkp_status_id == 19 || form.lkp_status_id == 0)">
            <!-- <w-button class="my1"  :loading="form.submitted && !form.sent" @click="send(2); onSuccess()"> -->
               <w-button class="my1" bg-color="success" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(2)">
                 <w-icon dark tile class="mr2">fal fa-save</w-icon> SETERUSNYA
            </w-button>
        </template>
         <template v-else-if="activeTab == 2 && form.lkp_status_id == 19 ">
            <w-button class="my1" :loading="form.submitted && !form.sent" @click="send(2); onSuccess()">
                 <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
            </w-button>
            &nbsp;

            <w-button class="my1" bg-color="success" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(1)">
               <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
            </w-button>
        </template>
      </w-flex>
      <div class="mt2 text-left">
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup()">TUTUP</w-button>&nbsp;
      </div>

 
     
    <!-- </div> -->
  </z-page>
    </w-form>

     <w-dialog
          v-model="dialogGambar.show"
          :fullscreen="dialogGambar.fullscreen"
          width="700"
          :persistent="dialogGambar.persistent"
          :persistent-no-animation="dialogGambar.persistentNoAnimation"
          title-class="primary-dark1--bg white">
        <template #title>
                 MUAT NAIK GAMBAR
        </template>
                    <table class="w-table" color="light"  width="100%" style="border:none;">
                      <thead>
                        <tr>
                          <td class="w-table__header  text-left" width="1%" style="border:none;" >
                           <b>Cadangan spesifikasi gambar dan sijil</b><br>
                           &nbsp;&nbsp;&nbsp; 1. Posisi ternakan diambir pada posisi kiri dan nampak keseluruhan ternakan hingga kaki<br>
                           &nbsp;&nbsp;&nbsp; 2. Size minimum gambar ialah 480X640 piksel<br>
                           &nbsp;&nbsp;&nbsp; 3. Format gambar yang di terima ialah png, jpg, jpeg, untuk sijil ialah pdf<br>
                           &nbsp;&nbsp;&nbsp; 4. Size gambar dan sijil tidak boleh melebihi 10MB
                          </td>
                        </tr>
                      </thead>
                   </table>
                   <br>

            <w-form ref="form_gambar" v-model="form_gambar.valid" @validate="validateFormGambar" @success="success">

                <div class="w-flex wrap smd-column" >
                     <div class="grow " >
                        <template v-if="$zutil.anyRole(['2','5'])">
                           <w-input class="mt4" type="file" :preview="false" accept=" image/*" v-model="img" multiple>Muat Naik Gambar</w-input>
                          
                         <!--   <template v-for="dt, ind  in attahecmentImg">
                              <div class="fw-normal my1 fs-1">  
                                 <a :href="dt.url">{{ dt.name }}</a> <w-button  bg-color="error-dark1"  @click="deletelAttahecmentImg(dt.id)" ><w-icon xs >fal fa-trash</w-icon></w-button>
                              </div>
                           </template> -->
                        </template>
                     </div>
                  </div>

            </w-form>

            <template #actions>
            <div class="spacer" />
               <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialogGambar.show = false">TUTUP</w-button>

            <w-button class="ml1" :loading="dialogGambar.loading" @click="$refs.form_gambar.validate()">SIMPAN</w-button>

               <!-- <w-button class="ml1" :disabled="form_gambar.valid === false" @click="SimpanGambar(form_gambar.id);">SIMPAN</w-button> -->
            </template>
         </w-dialog>

         <w-dialog
          v-model="dialogSijil.show"
          :fullscreen="dialogSijil.fullscreen"
          width="700"
          :persistent="dialogSijil.persistent"
          :persistent-no-animation="dialogSijil.persistentNoAnimation"
          title-class="primary-dark1--bg white">
        <template #title>
                 MUAT NAIK SIJIL PEDIGREE
        </template>
                    <!-- <table class="w-table" color="light"  width="100%" style="border:none;">
                      <thead>
                        <tr>
                          <td class="w-table__header  text-left" width="1%" style="border:none;" >
                           <b>Cadangan spesifikasi gambar dan sijil</b><br>
                           &nbsp;&nbsp;&nbsp; 1. Posisi ternakan diambir pada posisi kiri dan nampak keseluruhan ternakan hingga kaki<br>
                           &nbsp;&nbsp;&nbsp; 2. Size minimum gambar ialah 480X640 piksel<br>
                           &nbsp;&nbsp;&nbsp; 3. Format gambar yang di terima ialah png, jpg, jpeg, untuk sijil ialah pdf<br>
                           &nbsp;&nbsp;&nbsp; 4. Size gambar dan sijil tidak boleh melebihi 2MB
                          </td>
                        </tr>
                      </thead>
                   </table> -->
                   <br>


            <w-form ref="form_sijil" v-model="dialogSijil.valid" @validate="validateFormSijil" @success="success">
                  <div class="w-flex wrap smd-column" >
                  <div class="grow " >
                     <template v-if="$zutil.anyRole(['2','5'])">
                          <w-input class="mt4" type="file" :preview="false" accept="image/*,application/pdf" v-model="files" multiple>Muat Naik Sijil Pedigree / Sijil Kelahiran</w-input>
                            <!-- <template v-for="dt, ind  in attahecment">
                                <div class="fw-normal my1 fs-1">  
                                  <a :href="dt.url">{{ dt.name }}</a> <w-button  bg-color="error-dark1"  @click="deletelAttahecment(dt.id)" ><w-icon xs >fal fa-trash</w-icon></w-button>
                                </div>
                            </template> -->
                     </template>
                  </div>
               </div>
            </w-form>

             <template #actions>
            <div class="spacer" />
               <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialogSijil.show = false">TUTUP</w-button>

               <w-button class="ml1" :loading="dialogSijil.loading" @click="$refs.form_sijil.validate()">SIMPAN</w-button>
            </template>
         </w-dialog>


         <w-dialog
          v-model="dialogDokumen.show"
          :fullscreen="dialogDokumen.fullscreen"
          width="700"
          :persistent="dialogDokumen.persistent"
          :persistent-no-animation="dialogDokumen.persistentNoAnimation"
          title-class="primary-dark1--bg white">
        <template #title>
                 BAKA DOKUMEN
        </template>
                    

            <w-form ref="form_dokumen" v-model="dialogDokumen.valid" @validate="validateFormDokumen" @success="success">
                  <div class="w-flex wrap smd-column" >
                  <div class="grow " >
                     <!-- <z-select style="margin:5px; " v-model="form_dokumen.id" :items="lkpbakaDokumen" label="Jenis Baka Dokumen *" v-if="form_dokumen.baka_dokumen_id == null" :validators="[validators.required]"/> -->
                     <template v-if="form_dokumen.id == null">
                          <w-input class="mt4" label="Jenis Baka Dokumen *" type="text" v-model="form_dokumen.is_baka_dokumen" v-if="form_dokumen.id == null" :validators="[validators.required]"/>
                        
                     </template>
                     <template v-else>
                          <w-input class="mt4" label="Jenis Baka Dokumen *" type="text" v-model="form_dokumen.is_baka_dokumen" v-if="form_dokumen.baka_dokumen_id == null" :validators="[validators.required]"/>
                     </template>
                     <template v-if="$zutil.anyRole(['2','5'])">
                          <w-input class="mt4" type="file" :preview="false" accept="image/*,application/pdf" v-model="files_dokumen" multiple>Muat Naik Baka Dokumen PDF</w-input>
                            <!-- <template v-for="dt, ind  in attahecment">
                                <div class="fw-normal my1 fs-1">  
                                  <a :href="dt.url">{{ dt.name }}</a> <w-button  bg-color="error-dark1"  @click="deletelAttahecment(dt.id)" ><w-icon xs >fal fa-trash</w-icon></w-button>
                                </div>
                            </template> -->
                     </template>
                     <template v-if="$zutil.anyRole(['2','5']) && form_dokumen.id == 2">
                        <w-input class="mt4" label="No Kes" type="text" v-model="form_dokumen.no_kes" />
                     </template>
                  </div>
               </div>
            </w-form>

             <template #actions>
            <div class="spacer" />
               <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialogDokumen.show = false">TUTUP</w-button>

               <w-button class="ml1" :loading="dialogDokumen.loading" @click="$refs.form_dokumen.validate()">SIMPAN</w-button>
            </template>
         </w-dialog>


          <w-dialog
          v-model="dialogTernakan.show"
          :fullscreen="dialogTernakan.fullscreen"
          width="700"
          :persistent="dialogTernakan.persistent"
          :persistent-no-animation="dialogTernakan.persistentNoAnimation"
          title-class="primary-dark1--bg white">
        <template #title>
                 Kemaskini Ternakan
        </template>
                    

            <w-form ref="form_ternakan" v-model="dialogTernakan.valid" @validate="validateFormTernakan" @success="success">
                  <div class="w-flex wrap smd-column" >
                  <div class="grow " >
                     ID | Nama Ternakan  &nbsp;&nbsp; :  &nbsp;&nbsp;{{form_ternakan.ternakan_nama}}
                     <!-- <template v-if="$zutil.anyRole(['2']) && form_ternakan.id_ibu == null"> -->
                        <w-input class="mt4" label="ID Induk" type="text" v-model="form_ternakan.id_ibu" :validators="[validators.required]"/>

                        <w-input class="mt4" label="Nama Induk *" type="text" v-model="form_ternakan.nama_ibu" :validators="[validators.required]"/>

                        <w-input class="mt4" label="ID Pejantan *" type="text" v-model="form_ternakan.id_bapa" :validators="[validators.required]"/>
                        
                        <w-input class="mt4" label="Nama Pejantan *" type="text" v-model="form_ternakan.nama_bapa" :validators="[validators.required]"/>

                        <!-- <w-input class="mt4" label="Warna Bulu" type="text" v-model="form_ternakan.warna" :validators="[validators.required]"/> -->

                        <z-select class="mt4" :items="lkp_warna" label="Warna Bulu *"  v-model="form_ternakan.lkp_warna_id"  :validators="[validators.required]"/>

                        <z-select class="mt4" :items="lkp_negara" label="Negara Asal *"  v-model="form_ternakan.negara_asal"  :validators="[validators.required]"/>
                     <!-- </template> -->

                     <!-- <template v-if="$zutil.anyRole(['2']) && form_ternakan.id_ibu != null">
                        <w-input class="mt4" label="ID Induk" type="text" v-model="form_ternakan.id_ibu" disabled/>

                        <w-input class="mt4" label="Nama Induk" type="text" v-model="form_ternakan.nama_ibu" disabled/>

                        <w-input class="mt4" label="ID Pejantan" type="text" v-model="form_ternakan.id_bapa" disabled/>
                        
                        <w-input class="mt4" label="Nama Pejantan" type="text" v-model="form_ternakan.nama_bapa" disabled/>
                     </template> -->




                     
                  </div>
               </div>
            </w-form>

             <template #actions>
            <div class="spacer" />
               <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialogTernakan.show = false">TUTUP</w-button>
               <template v-if="$zutil.anyRole(['2','5']) ">
                   <w-button class="ml1" :loading="dialogTernakan.loading" @click="$refs.form_ternakan.validate()">SIMPAN</w-button>
               </template>
            </template>
         </w-dialog>



  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    id: [Array, Object],
    d_form: [Array, Object],
    d_lkp_negeri: [Array, Object]
  

  },
  data() {
    return {
      resourceurl: 'baka',
      searchQuery: '', 
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pensijilan Ternakan Baka', route: '/baka' },
        { label: 'Sijil Baka', route: '/baka' },
        { label: 'Permohonan', route: '/baka/permohonan' },
      ],
       tabs: [
           { title: 'PERMOHONAN', content: '' },
            { title: 'TERNAKAN', content: ''},
            // { title: 'MUAT NAIK DOKUMEN', content: ''},
          ],
      pasung_list:[
        {value: 1, label: "Ada"},
        {value: 2, label: "Tiada"},
      ],
      negeri : '',
      title : 'BAKA  Permohonan',
      form : this.d_form,
      lkp_negeri : this.d_lkp_negeri,
      ternakan_list:[],
      baka_dokumen_list:[],
      premis : [],
      lkp_ternakan : [],
      jenis_baka : [],
      lkpbakaDokumen : [],
      lkp_negara: [],
      lkp_warna: [],
      slides:[],
      tarikh_today:'',
      activeTab : 0,
      checkin:false,
      loading:false,
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
          width: 900,
        item: {}
      },
      dialogGambar: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
          width: 1800,
        item: {}
      },
      dialogSijil: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
          width: 1800,
        item: {}
      },
      dialogDokumen: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
          width: 1800,
        item: {}
      },
      dialogTernakan: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
          width: 1800,
        item: {}
      },
      files_dokumen:[],
      files:[],
      img:[],
      attahecment:[],
      attahecmentImg:[],
    
    }
  },
    computed: {
    filteredTernakanList() {
      // Jika tiada carian, pulangkan semua data
      if (!this.searchQuery) {
        return this.ternakan_list;
      }

      // Tukar carian kepada huruf kecil untuk case-insensitive
      const query = this.searchQuery.toLowerCase();

      // Tapis data
      return this.ternakan_list.filter(item => {
        const id = item.id_ternakan ? String(item.id_ternakan).toLowerCase() : '';
        const nama = item.nama_ternakan ? String(item.nama_ternakan).toLowerCase() : '';
        const kode = item.kode ? String(item.kode).toLowerCase() : ''; // No Pendaftaran
        
        // Gabungkan semua untuk "Full Carian"
        return id.includes(query) || 
               nama.includes(query) || 
               kode.includes(query) ||
               `${id} ${nama}`.includes(query); // Carian gabungan ID + Nama
      });
    }
  },
  methods: {
   Gambar(dt){
    this.form_gambar = {
        id: dt.id,   // ⬅️ ini baka_butiran_id
    }
    this.img = ''
    this.getAttahecmentImg(dt.id)   // ⬅️ guna baka_butiran_id
    this.dialogGambar.show = true;
},

   Sijil(dt){
         this.form_sijil = {
             id : dt.id,
         }
         this.files = ''

         this.getAttahecment(dt.id)

        this.dialogSijil.show = true;
        this.dialogSijil.show = true;
    },

   Dokumen(dt){
         this.form_dokumen = {
             id : dt.id,
             no_kes : dt.no_kes,
             baka_id : dt.baka_id,
             baka_dokumen_id : dt.baka_dokumen_id,
             is_baka_dokumen : dt.nama,
         }
         this.files_dokumen = ''

         this.getAttahecmentDokumen(dt.id)

        this.dialogDokumen.show = true;
    },

   Dokumen_baru(baka){
         this.form_dokumen = {
             id : '',
             no_kes : '',
             baka_id : baka.id,
             baka_dokumen_id : null,
             is_baka_dokumen : '',
         }

         this.files_dokumen = ''

         this.getLkpBakaDokumen()

        this.dialogDokumen.show = true;
    },

    Ternakan(dt){
         this.form_ternakan = {
             ternakan_id : dt.ternakan_id,
             ternakan_nama : dt.ternakan_nama,
             id_ibu : dt.id_ibu,
             nama_ibu : dt.nama_ibu,
             id_bapa : dt.id_bapa,
             nama_bapa : dt.nama_bapa,
             lkp_warna_id : dt.lkp_warna_id ?? '',
             negara_asal : dt.negara_asal ?? '',
         }

        this.dialogTernakan.show = true;
    },

        klickPilih(){
        // TUKAR this.ternakan_list KEPADA this.filteredTernakanList
        for (var b in this.filteredTernakanList) {
          if (this.filteredTernakanList[b].baka == null) {
            this.filteredTernakanList[b].pilih = this.checkin
          }
        }
     },

      klickPi(dt){
         if(dt.pilih == false){
            dt.jenis_semen = 0;
         }
      },

    getPremis(){
      this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
        this.premis = res
        if (this.premis.length == 1) {
         for (var p in this.premis) {
            this.form.premis_id = this.premis[p].value;
            this.form.lkp_negeri_id = this.premis[p].lkp_negeri_id;
            this.form.lkp_negeri = this.premis[p].lkp_negeri;
         }
        }
      })
    },

    getData(){
      this.getTernakan(this.d_form, 1);
    },

   getTernakan(data, item){
   if(item == 2){
      this.form.lkp_ternakan_id = 0;
      // this.form.juruteknik_id = 0;
      if(data.premis_id !='' && data.lkp_ternakan_id !='' && data.lkp_jenis_baka_id != ''){
        this.$zcomm.get(this.api_service + 'baka/ternakan_baka/'+data.premis_id+'/'+data.lkp_ternakan_id+'/'+data.lkp_jenis_baka_id, {}).then(res => {
          this.ternakan_list = res
          if(data.ternakan_list.length > 0){
            for (var i in this.ternakan_list) {
              for (var t in data.ternakan_list) 
              {
                if(this.ternakan_list[i].ternakan_id == data.ternakan_list[t].ternakan_id){
                  
                  this.ternakan_list[i].pilih = true;
                  this.ternakan_list[i].sudah_pilih = 1;
                }
              }
            }

          }
        })
      }
      // this.getJuruteknik(this.d_form);

   }else if(item == 3){
         if(data.premis_id !='' && data.lkp_ternakan_id !='' && data.lkp_jenis_baka_id != ''){
        this.$zcomm.get(this.api_service + 'baka/ternakan_baka/'+data.premis_id+'/'+data.lkp_ternakan_id+'/'+data.lkp_jenis_baka_id, {}).then(res => {
          this.ternakan_list = res
          if(data.ternakan_list.length > 0){
            for (var i in this.ternakan_list) {
              for (var t in data.ternakan_list) 
              {
                if(this.ternakan_list[i].ternakan_id == data.ternakan_list[t].ternakan_id){
                  
                  this.ternakan_list[i].pilih = true;
                  this.ternakan_list[i].sudah_pilih = 1;
                }
              }
            }

          }
        })
        // this.activeTab=1;
      // this.getJuruteknik(this.d_form);


       }

   }else if(item == 1){
      if(data.premis_id !='' && data.lkp_ternakan_id !='' && data.lkp_jenis_baka_id != ''){
        this.$zcomm.get(this.api_service + 'baka/ternakan_baka/'+data.premis_id+'/'+data.lkp_ternakan_id+'/'+data.lkp_jenis_baka_id, {}).then(res => {
          this.ternakan_list = res
          if(data.ternakan_list.length > 0){
            for (var i in this.ternakan_list) {
              for (var t in data.ternakan_list) 
              {
                if(this.ternakan_list[i].ternakan_id == data.ternakan_list[t].ternakan_id){
                  
                  this.ternakan_list[i].pilih = true;
                  this.ternakan_list[i].sudah_pilih = 1;
                }
              }
            }

          }
        })
        this.activeTab=2;
      // this.getJuruteknik(this.d_form);


      }
   }else{
      if(data.premis_id !='' && data.lkp_ternakan_id !='' && data.lkp_jenis_baka_id !=''){
        this.$zcomm.get(this.api_service + 'baka/ternakan_baka/'+data.premis_id+'/'+data.lkp_ternakan_id+'/'+data.lkp_jenis_baka_id, {}).then(res => {
          this.ternakan_list = res
          if(data.ternakan_list.length > 0){
            for (var i in this.ternakan_list) {
              for (var t in data.ternakan_list) 
              {
                if(this.ternakan_list[i].ternakan_id == data.ternakan_list[t].ternakan_id){
                  
                  this.ternakan_list[i].pilih = true;
                  this.ternakan_list[i].sudah_pilih = 1;
                }
              }
            }

          }
        })
        this.activeTab=1;
      // this.getJuruteknik(this.d_form);


      }
    }
      for (var b in this.premis) 
      {
        if(this.premis[b].value == data.premis_id){
          this.form.lkp_negeri_id = this.premis[b].lkp_negeri_id;
          this.form.lkp_negeri = this.premis[b].lkp_negeri;
          // this.getJuruteknik(data);
          // this.activeTab=1;

        }
      }
      
    },


    send(hantar){
      this.form.hantar = hantar
    },

    validateForm() {
      this.loading=true;
      let isValid = true;
      let jumlah_lulus = 0;
      
      if(this.form.hantar == 1){ 
         if(this.form.id > 0){ 
            for (var i in this.form.ternakan_list) {
               if (this.form.ternakan_list[i].gambar_nama == null || this.form.ternakan_list[i].sijil_nama == null || this.form.ternakan_list[i].id_ibu == null) {
                  isValid = false;
                  break;
               }

               // if(this.ternakan_list[i].pilih==true && this.ternakan_list[i].jenis_semen!=0){
               //    jumlah_lulus = 1;
               // }

            };

            for (var h in this.form.baka_dokumen_list) {
               // if (this.form.baka_dokumen_list[h].no_kes == null || this.form.baka_dokumen_list[h].dokumen_nama == null) {
               if (this.form.baka_dokumen_list[h].dokumen_nama == null && this.form.baka_dokumen_list[h].no_kes == null) {
                  isValid = false;
                  break;
               }
            };

            jumlah_lulus = 1;
         }
      }else if(this.form.hantar == 2){
         if(this.form.id > 0){ 
                  jumlah_lulus = 1;

         }else{
            for (var i in this.ternakan_list) {

               if(this.ternakan_list[i].pilih==true){
                  jumlah_lulus = 1;
               }

            };

         }

      }
      if(jumlah_lulus == 0 && isValid == true){
         isValid = false;
      }
      if(!this.form.premis_id ||  !this.form.lkp_ternakan_id || !this.form.lkp_jenis_baka_id){
         isValid = false;
      }
      if (!isValid) {
        this.$zutil.notify("Pastikan data sudah terisi", false);
        this.loading=false;
        return false;
      }
      // this.datas.hantar = 1;
      this.onSuccess();
    },



    onSuccess(){
      // this.form.ternakan_list = this.ternakan_list;
       // this.form.lkp_tujuan_id = 10;
       this.form.web = 1;
      if(this.form.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if (this.form.id > 0){
               this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
                .then(res => {
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  if (this.form.hantar==1) {
                      this.$inertia.visit(this.$route('baka.index'));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                })
              }
            }
          })
      }else{
        if (this.form.id > 0) 
        { 

      this.form.ternakan_list = this.ternakan_list;
          this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('baka.permohonan', this.form.id));
                  this.activeTab=3;
          })
        }
        else 
        {

      this.form.ternakan_list = this.ternakan_list;

          this.$zcomm.post(this.resourceurl+'.store' , this.form)
          .then(res => {
            if (typeof this.onAfterAdd === "function") {
              this.onAfterAdd()
            }

            this.$zutil.notify("Berjaya disimpan", true);
            // this.$inertia.visit(this.$route('baka.permohonan', res.id));
            this.$inertia.visit(this.$route('baka.permohonan',res.id));
            // this.activeTab=3;

          })
        }
      } 
      
    },

     destroyTernakan(id)
          {
            this.$swal({
              title: 'Anda Pasti?',
              // text: "Are you sure want to delete this item!",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ya',
              cancelButtonText: 'Tidak'
            }).then((result) => {
              if (result.value) {
                this.$zcomm.delete(this.resourceurl + '.destroy',id)
                .then(res => {
                  this.sending = false;
                  this.$inertia.visit(this.$page.url)
                  this.removeitem(res) // remove the data from list. no need to refresh page
                  if (typeof this.onAfterDelete === "function") {
                    this.onAfterDelete()
                    this.deletelAttahecmentImg(id)
                    this.deletelAttahecment(id)
                  }
                })
                .finally(() => {
                  // $('#' + this.resourceurl).modal('hide')
                });
              }else{ }
              })

          },

      destroyDokumen(id)
          {
            this.$swal({
              title: 'Anda Pasti?',
              // text: "Are you sure want to delete this item!",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ya',
              cancelButtonText: 'Tidak'
            }).then((result) => {
              if (result.value) {
                this.$zcomm.delete(this.resourceurl + '.destroy_dokumen',id)
                .then(res => {
                  this.sending = false;
                  this.$inertia.visit(this.$page.url)
                  this.removeitem(res) // remove the data from list. no need to refresh page
                  if (typeof this.onAfterDelete === "function") {
                    this.onAfterDelete()
                    this.deletelAttahecmentDokumen(id)
                  }
                })
                .finally(() => {
                  // $('#' + this.resourceurl).modal('hide')
                });
              }else{ }
              })

          },
    
    
    
   getJenisTernakan(){
         this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
           this.lkp_ternakan = res
         })
       },

   getJenisBaka(){
         this.$zcomm.get(this.api_service + 'lookup/jenis_baka', {}).then(res => {
           this.jenis_baka = res
         })
       },

   tutup(){
         this.$inertia.visit(window.route('baka.index'));
       },


      validateFormGambar() {
         this.loading = true;
         let isValid = true;

          // Pastikan ada gambar
         if (!this.img || this.img.length === 0) {
            isValid = false;
            this.$zutil.notify("Sila pilih gambar untuk dimuat naik", false);
            this.loading = false;
            return false;
         }

         // Validasi ukuran maksimum 200KB per file
         // const MAX_SIZE = 200 * 1024; // 200KB
         const MAX_SIZE = 10 * 1024 * 1024; // 2 MB
         for (let i = 0; i < this.img.length; i++) {
             const file = this.img[i];
    
            if (file.size > MAX_SIZE) {
               this.$zutil.notify(`"${file.name}" melebihi saiz maksimum 10MB.`, false);
               this.loading = false;
               return false;
            }

            // Validasi tipe file (opsional)
            if (!file.type.startsWith("image/")) {
               this.$zutil.notify(`"${file.name}" bukan jenis gambar yang sah.`, false);
               this.loading = false;
               return false;
            }
         }

         // Jika lolos semua validasi, lanjutkan
         this.submitGambar();
      },

    submitGambar() {
      if (this.img.length > 0) {
          this.uploadImg(this.form_gambar.id);   // ⬅️ guna baka_butiran_id
      }
      this.dialogGambar.show = false;
  },

  
   uploadImg(item) {
    let formData = new FormData();
    for (var b in this.img) {
        formData.append("files[" + b + "]", this.img[b].file);
    }
    formData.append("model", '\\App\\Model\\BakaButiran');   // ⬅️ TUKAR BALIK
    formData.append("model_id", item);

    this.$zcomm.post('attahecment.upload', formData)
        .then((res) => {
            this.getAttahecmentImg(item);
            this.loadData();
        })
        .catch((err) => {})
        .finally(() => {});
},


    
   deletelAttahecmentImg(id) {
    if (confirm('Are you sure to delete this record?')) {
        this.$zcomm.get(this.$route('attahecment.delete', id), {})
            .then(res => {
                this.getAttahecmentImg(this.form_gambar.id);   // ⬅️ guna baka_butiran_id
                this.loadData();
            })
    }
},
    getAttahecmentImg(item) {
    this.$zcomm.get(this.api_service + 'attahecment/list', {
        model_id: item,
        model: '\\App\\Model\\BakaButiran'   // ⬅️ TUKAR BALIK
    }).then(res => {
        this.attahecmentImg = res
        this.slides = [];
        for (var b in this.attahecmentImg) {
            this.slides.push({
                title: this.attahecmentImg[b].information,
                image: this.attahecmentImg[b].url
            })
        }
    })
},


   validateFormSijil() {
      this.loading = true;
      let isValid = true;

      // Pastikan file ada
      if (!this.files || this.files.length === 0) {
         isValid = false;
         this.$zutil.notify("Sila pilih fail sijil untuk dimuat naik", false);
         this.loading = false;
         return false;
      }

      // const MAX_SIZE = 2 * 1024 * 1024; // 2 MB

      // for (let i = 0; i < this.files.length; i++) {
      //    const file = this.files[i].file || this.files[i]; // tergantung struktur this.files

      //    // Validasi ukuran
      //    if (file.size > MAX_SIZE) {
      //       this.$zutil.notify(`"${file.name}" melebihi saiz maksimum 2MB.`, false);
      //       this.loading = false;
      //       return false;
      //    }

      //    // Validasi jenis file harus PDF
      //    if (file.type !== "application/pdf" && !file.name.endsWith(".pdf")) {
      //       this.$zutil.notify(`"${file.name}" bukan fail PDF.`, false);
      //       this.loading = false;
      //       return false;
      //    }
      // }

      // Lolos semua validasi
      this.submitSijil();
   },

    submitSijil() {
            // this.$swal({
            //   title: 'Anda Pasti?',
            //   // text: "Are you sure want to delete this item!",
            //   type: 'warning',
            //   showCancelButton: true,
            //   confirmButtonColor: '#3085d6',
            //   cancelButtonColor: '#d33',
            //   confirmButtonText: 'Ya',
            //   cancelButtonText: 'Tidak'
            // })
            // .then((result) => {
            //     if (result.value) {
                       
                  if (this.files.length > 0) {
                     this.uploadPDF(this.form_sijil.id);
                  }
                  this.dialogSijil.show = false;
            //     }else{ }

            // })

    },




    uploadPDF(item) 
    {  
       let formData = new FormData();
       for (var b in this.files) 
       {
           formData.append("files["+b+"]", this.files[b].file);
       }
       formData.append("model",'\\App\\Model\\BakaButiranSijil');
       formData.append("model_id", item);
       this.$zcomm.post('attahecment.upload_replace', formData)
           .then((res) => {
               this.getAttahecment();
               this.loadData();
           })
           .catch((err) => {})
           .finally(() => {});
   },
   


    getAttahecment(item)
    {
      this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : item, model : '\\App\\Model\\BakaButiranSijil'}).then(res => {
         this.attahecment = res
         // this.slides = [];
         // for (var b in this.attahecment) {
         //    this.slides.push({title: this.attahecment[b].information, image: this.attahecment[b].url})
         // }
      })
    },

   deletelAttahecment(id)
   {
    if (confirm('Are you sure to delete this record?')) {
       this.$zcomm.get(this.$route('attahecment.delete', id), {})
       .then(res => {
        this.getAttahecment();
         this.loadData();
       })
     }
   },


  validateFormDokumen() {
      this.loading=true;
      let isValid = true;
      let jumlah_lulus = 0;
         for (var i in this.baka_dokumen_list) {
            if (!this.baka_dokumen_list[i].no_kes) {
               isValid = false;
               break;
            }
         };

         for (var h in this.form.baka_dokumen_list) {
               if (this.form.baka_dokumen_list[h].no_kes == null && this.form.baka_dokumen_list[h].dokumen_nama == null) {
                   if ((!this.files_dokumen || this.files_dokumen.length === 0) && this.form_dokumen.no_kes === null) {
                     isValid = false;
                     this.$zutil.notify("Sila pilih fail sijil dimuat naik atau isi No Kes", false);
                     this.loading = false;
                     return false;
                  }

               }
              


         };



         // if (!this.files_dokumen || this.files_dokumen.length === 0) {
         //       isValid = false;
         //       this.$zutil.notify("Sila pilih fail sijil untuk dimuat naik", false);
         //       this.loading = false;
         //       return false;
         // }

         if (!this.form_dokumen.id && (!this.files_dokumen || this.files_dokumen.length === 0)) {
            if (this.form_dokumen.is_baka_dokumen === null ){
               isValid = false;
               this.$zutil.notify("Pastikan data sudah terisi", false);
               this.loading = false;
               return false;
            }
         }


         //  if (!this.form_dokumen.no_kes) {
         //       isValid = false;
         //       this.$zutil.notify("Sila isi no_kes", false);
         //       this.loading = false;
         //       return false;
         // }

         // const MAX_SIZE = 2 * 1024 * 1024; // 2 MB

         // for (let i = 0; i < this.files_dokumen.length; i++) {
         //    const file = this.files_dokumen[i].file || this.files_dokumen[i]; // tergantung struktur this.files

         //    // Validasi ukuran
         //    if (file.size > MAX_SIZE) {
         //       this.$zutil.notify(`"${file.name}" melebihi saiz maksimum 2MB.`, false);
         //       this.loading = false;
         //       return false;
         //    }

         //    // Validasi jenis file harus PDF
         //    if (file.type !== "application/pdf" && !file.name.endsWith(".pdf")) {
         //       this.$zutil.notify(`"${file.name}" bukan fail PDF.`, false);
         //       this.loading = false;
         //       return false;
         //    }
         // }

         if (!isValid) {
            this.$zutil.notify("Pastikan data sudah terisi", false);
            this.loading=false;
            return false;
         }
       this.submitBakaDokumen();
    },

    submitBakaDokumen() {
  if (this.form_dokumen.no_kes) {
    this.$zcomm.get(this.api_service + 'check_integrasi/kes/' + encodeURIComponent(this.form_dokumen.no_kes), {})
      .then(res => {
        if (!res) {
          this.$zutil.notify("No Kes tidak wujud, sila rujuk Myvetlab", false);
        } else {
          this.simpanBakaDokumen();
        }
      })
      .catch(err => {
        this.$zutil.notify("No Kes tidak wujud, sila rujuk Myvetlab", false);
        console.error(err);
      });
  } else {
    this.simpanBakaDokumen();
  }
},

simpanBakaDokumen() {
  this.$zcomm.post(this.resourceurl + '.store_baka_dokumen', this.form_dokumen)
    .then(res => {
      if (typeof this.onAfterAdd === "function") {
        this.onAfterAdd()
      }
      if (this.files_dokumen.length > 0) {
        this.uploadPDFDokumen(res.id);
      }
      this.$zutil.notify("Berjaya disimpan", true);
      this.loadData();
      this.dialogDokumen.show = false;
    })
    .catch(err => {
      this.$zutil.notify("Ralat semasa menyimpan", false);
      console.error(err);
    });
},

    

   uploadPDFDokumen(item) 
    {  
       let formData = new FormData();
       for (var b in this.files_dokumen) 
       {
           formData.append("files["+b+"]", this.files_dokumen[b].file);
       }
       formData.append("model",'\\App\\Model\\BakaDokumen');
       formData.append("model_id", item);
       this.$zcomm.post('attahecment.upload_replace', formData)
           .then((res) => {
               this.getAttahecmentDokumen();
               this.loadData();
           })
           .catch((err) => {})
           .finally(() => {});
   },
   


    getAttahecmentDokumen(item)
    {
      this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : item, model : '\\App\\Model\\BakaDokumen'}).then(res => {
         this.attahecment = res
         // this.slides = [];
         // for (var b in this.attahecment) {
         //    this.slides.push({title: this.attahecment[b].information, image: this.attahecment[b].url})
         // }
      })
    },

   deletelAttahecmentDokumen(id)
   {
    if (confirm('Are you sure to delete this record?')) {
       this.$zcomm.get(this.$route('attahecment.delete', id), {})
       .then(res => {
        this.getAttahecment();
         this.loadData();
       })
     }
   },


   loadData() {
      if(this.form.id > 0){
        this.$zcomm.get(this.api_service + 'baka/show/'+this.form.id, {}).then(res => {
          this.form = res
          this.load = this.load + 1
        })
      }

    },

    getLkpBakaDokumen(){
      this.$zcomm.get(this.api_service + 'lookup/lkp_baka_dokumen', {}).then(res => {
        this.lkpbakaDokumen = res
      })
    },

   validateFormTernakan() {
      this.loading=true;
      let isValid = true;
      // let jumlah_lulus = 0;
         // for (var i in this.ternakan_list) {
         //    if (this.ternakan_list[i].id_ibu  == null && this.ternakan_list[i].nama_ibu == null && this.ternakan_list[i].id_bapa == null && this.ternakan_list[i].nama_bapa == null) {
         //       isValid = false;
         //       break;
         //    }
         // };


            if (this.form_ternakan.id_ibu == null ){
               isValid = false;
               this.$zutil.notify("Pastikan data sudah terisi ID Induk", false);
               this.loading = false;
               return false; 
            }else if(this.form_ternakan.nama_ibu == null){
               isValid = false;
               this.$zutil.notify("Pastikan data sudah terisi Nama Induk", false);
               this.loading = false;
               return false; 
            }else if(this.form_ternakan.id_bapa == null){
               isValid = false;
               this.$zutil.notify("Pastikan data sudah terisi Nama Pejantan", false);
               this.loading = false;
               return false; 
            }else if(this.form_ternakan.nama_bapa == null){
               isValid = false;
               this.$zutil.notify("Pastikan data sudah terisi Nama Pejantan", false);
               this.loading = false;
               return false; 
            }else if(this.form_ternakan.lkp_warna_id == null){
               isValid = false;
               this.$zutil.notify("Pastikan data sudah terisi Warna", false);
               this.loading = false;
               return false;
            }else if(this.form_ternakan.negara_asal == null){
               isValid = false;
               this.$zutil.notify("Pastikan data sudah terisi Negara Asal", false);
               this.loading = false;
               return false;
            }

         if (!isValid) {
            this.$zutil.notify("Pastikan data sudah terisi semua", false);
            this.loading=false;
            return false;
         }

       this.submitTernakan();
    },

    submitTernakan() {
      this.$zcomm.post(this.resourceurl+'.update_ternakan' , this.form_ternakan)
         .then(res => {
         
         if (typeof this.onAfterAdd === "function") {
            this.onAfterAdd()
         }
         this.$zutil.notify("Berjaya disimpan", true);

         this.loadData();
         this.dialogTernakan.show = false;
         })
         
          .catch(err => {
            this.$zutil.notify("Ralat semasa menyimpan", false);
            console.error(err);
        });

    },

   url_kes(kes) {
      this.$zcomm.get(this.api_service + 'integrasi/kes/' + encodeURIComponent(kes), {}).then(res => {
          res.urls.forEach(url => {
             window.open(url, "_blank")
          })
    
      })
       .catch(err => {
            this.$zutil.notify("no_kes: Tiada dalam sistem MyVetLab", false);
            console.error(err);
        });
   },

   getNegara(){
      this.$zcomm.get(this.api_service + 'lookup/negara', {}).then(res => {
        this.lkp_negara = res
      })
    },
    getWarna(){
         this.$zcomm.get(this.api_service + 'lookup/warna', {}).then(res => {
           this.lkp_warna = res
         })
       },

   updateTabs(id) {
      this.tabs = [
         
           { title: 'PERMOHONAN', content: '' },
            { title: 'TERNAKAN', content: ''},
            // { title: 'MUAT NAIK DOKUMEN', content: ''},
      ]

      if (id > 1) {
         this.tabs.push({ title: 'MUAT NAIK DOKUMEN', content: '' })
      }
   },

      // updateActiveTab(status) {
      //    // logika aktif otomatis sesuai status perubahan
      //    switch (status) {
      //       case 7:   // status MATI/LUPU
      //          this.activeTab = this.tabs.findIndex(t => t.title === 'MATI/LUPUS')
      //       break
            

      //       default:  // lainnya → buka tab pertama
      //       this.activeTab = 0
      //    }
      //    // jika hasil findIndex -1 (tidak ditemukan), fallback ke 0
      //    if (this.activeTab < 0) this.activeTab = 0
      // },

       


  
  },

  watch: {
   d_form: {
    handler(newVal) {
      if (!newVal) return
      this.updateTabs(newVal.id)
      // this.updateActiveTab(newVal.lkp_status_perubahan_id)
    },
    immediate: true
  }

  },
  mounted() {
    var today = new Date();
    this.tarikh_today = today.toISOString().split('T')[0];
    if(this.id > 0)
    {
      this.title = 'Tambah PPERMOHONAN PENSIJILAN TERNAKAN BAKA'
    }
    else
    {
      this.title = 'Tambah PERMOHONAN PENSIJILAN TERNAKAN BAKA'
    }
    this.getPremis()
    this.getData()
    this.getJenisTernakan()
    this.getJenisBaka()
    this.getNegara()
    this.getWarna()
    // this.getTernakanList()
  }
    
}
</script>
<style scoped>
.search-input-custom .w-input__element {
   background-color: #ffffff;
   border-color: #ced4da;
   border-radius: 6px;
   transition: all 0.2s ease-in-out;
}
.search-input-custom .w-input__element:focus {
   border-color: #007bff;
   box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
</style>
